import useToastContext from "hooks/useToastContext";
import { isEmpty } from "lodash";
import Fab from "pages/test_manager/components/Fab";
import { useEffect, useState } from "react";
import { TiPencil, TiPlus } from "react-icons/ti";
import { apiGet } from "utils/apiFetch";
import apiPath from "utils/apiPath";
import { useNavigate } from "react-router-dom";
import Pagination from "pages/test_manager/components/Pagination";

export default function ListBanksPage() {
  const notification = useToastContext();
  const navigate = useNavigate();
  const [banks, setBanks] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  useEffect(() => {
    const fetchBanks = async () => {
      try {
        const response = await apiGet(apiPath.banks, { page });
        if (response?.data?.results?.docs) {
          setBanks(response?.data?.results?.docs || []);
          setTotalPages(response?.data?.results?.totalPages || 1);
        } else {
          notification.error("No banks found");
        }
      } catch (error) {
        notification.error("Something went wrong");
        console.log(error);
      }
    };
    fetchBanks();
  }, [notification, page]);

  const handleEdit = (bank) => {
    navigate(`/bank-manager/bank/${bank._id}`);
  };

  return (
    <div className="bg-white px-2 py-4 flex flex-col gap-4">
      <h1 className="text-2xl font-bold">Banks Manager</h1>

      <table className="w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400">
        <thead className="text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
          <tr>
            <th scope="col" className="py-3 px-6">
              #
            </th>
            <th scope="col" className="py-3 px-6">
              Bank Name (English)
            </th>
            <th scope="col" className="py-3 px-6">
              Bank Name (Arabic)
            </th>
            <th scope="col" className="py-3 px-6">
              Account Name
            </th>
            <th scope="col" className="py-3 px-6">
              Account Name (Arabic)
            </th>
            <th scope="col" className="py-3 px-6">
              Iban
            </th>
            {/* <th scope="col" className="py-3 px-6">
              Status
            </th> */}
            <th scope="col" className="py-3 px-6">
              Action
            </th>
          </tr>
        </thead>
        <tbody className="text-gray-900 dark:text-gray-400">
          {isEmpty(banks) && (
            <tr>
              <td colSpan={8} className="py-3 px-6 text-center">
                No banks found
              </td>
            </tr>
          )}
          {banks.map((bank, index) => (
            <tr
              key={index}
              className="bg-white border-b dark:bg-gray-800 dark:border-gray-700"
            >
              <td className="py-3 px-6">{index + 1}</td>
              <td className="py-3 px-6">{bank.bankName}</td>
              <td className="py-3 px-6">{bank.bankNameAr}</td>
              <td className="py-3 px-6">{bank.accountName}</td>
              <td className="py-3 px-6">{bank.accountNameAr}</td>
              <td className="py-3 px-6">{bank.ibanNo}</td>
              {/* <td className="py-3 px-6">{bank.status}</td> */}
              <td className="py-3 px-6">
                <button
                  className="bg-blue-500 text-white p-2 rounded-md"
                  onClick={() => handleEdit(bank)}
                >
                  <TiPencil size={16} />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <Pagination page={page} setPage={setPage} totalPages={totalPages} />

      <Fab onClick={() => navigate("/bank-manager/bank")}>
        <TiPlus size={16} /> Add Bank
      </Fab>
    </div>
  );
}
